
import React from 'react';

import Footer from '../footer/Footer';
import PremierPlans from './PremierPlans';
import { makeStyles, Theme, createStyles, Container, Typography, Link } from '@material-ui/core';
import OtherPlans from './OtherPlans';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
        heroContent: {
            padding: theme.spacing(8, 0, 6),
        },
        root: {
            paddingTop: theme.spacing(8),
            display: "flex",
            flexDirection: "column",
        },
  }),
);


const Pricing: React.FC = () => {

    const classes = useStyles();
 
    return  (<div className={classes.root}>
        
        <Container maxWidth="md" component="main" className={classes.heroContent}>
            <Typography component="h1" variant="h4" align="center" color="textPrimary" gutterBottom>
            Premier plans
            </Typography>
            <Typography variant="h6" align="center" color="textSecondary" component="p">
                Each one of the plans enables you to have a co-branded HD group call with specialized interview tools
            </Typography>
            <Typography variant="h6" align="center" color="textSecondary" component="p">
                In case you would have any pricing questions, please email us at <Link href="mailto:office@meet.rs">office@meet.rs</Link>
            </Typography>

        </Container>    

        <PremierPlans />

        <Container maxWidth="md" component="main" className={classes.heroContent}>
            <Typography component="h1" variant="h4" align="center" color="textPrimary" gutterBottom>
            Other plans
            </Typography>
            <Typography variant="h6" align="center" color="textSecondary" component="p">
                If you already use tools like Zoom for the call, code only plan is probably a better option. <br />
            </Typography>
            <Typography variant="h6" align="center" color="textSecondary" component="p">
                If you are interested in integrating Meet into your product, partner plan is likely what you need.<br />
            </Typography>
        </Container>    

        <OtherPlans />

        <Container maxWidth="md" component="main" className={classes.heroContent} >
            <Typography component="h3" variant="h4" align="center" color="textPrimary" gutterBottom>
                Our pricing guarantees
            </Typography>
            <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
                We're so convinced you'll absolutely love our services, that we're willing to offer a 30 day risk-free money back guarantee.
            </Typography>
            <Typography variant="subtitle1" align="center" color="textSecondary" component="p">
                In case any of your Meets is not meeting your quality expectations, we will not charge for it - 
            </Typography>
        </Container>    

        <Footer />

    </div>);

}

export default Pricing;
